import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

export const FiltersWrapper = withConfig(theme => styled('div', { label: 'FiltersWrapper' })`
    background-color: ${theme.star.filtersColors.wrapper.bgColorQuaternary};
    padding: 8px 0 8px 8px;
`);

export const RaceCardChevronIconWrapper = styled(ChevronIcon, { label: 'RaceCardChevronIconWrapper' })`
    fill: currentcolor;
    flex: 0 0 12px;
    margin-left: 4px;
`;

interface SportsMeetingsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    isAntePostReverse: boolean;
}

const setSportsMeetingsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background: ${theme.star.quickPick.bgColorSeptenary};
            @media ${theme.star.mediaQuery.tablet} {
                margin: 0 8px;
                border-radius: ${theme.star.radius.medium};
                overflow: hidden;
            }
        `;
    }
    return css``;
};

export const SportsMeetingsWrapper = withConfig(theme => styled('div', { label: 'SportsMeetingsWrapper' }) <SportsMeetingsWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setSportsMeetingsWrapper(variant, theme)};
    @media ${theme.star.mediaQuery.tablet} {
        margin-bottom: ${({ isAntePostReverse }): string => isAntePostReverse ? '20px' : '0'};
    }
`);

interface RaceWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
            margin: 0 8px 8px;
            @media ${theme.star.mediaQuery.tablet} {
                margin: 0;
            }
        `;
    }
    return css``;
};

export const RaceWrapper = withConfig(theme => styled('div', { label: 'RaceWrapper' })<RaceWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setRaceWrapper(variant, theme)};
`);

interface MobileViewPropsType {
    variant: DefaultComponentVariantType | null;
}


export const MobileView = withConfig(theme => styled('div', { label: 'MobileView' })<MobileViewPropsType>`
    margin-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '8px' : '0'};
    display: block;
    @media ${theme.star.mediaQuery.tablet} {
        display: none;
    }
`);

export const BuildRaceCardButton = styled(Button, { label: 'BuildRaceCardButton' })`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 10px;
`;

interface BuildRaceCardButtonWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setBuildRaceCardButtonWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium};
        `;
    }
    return css``;
};

export const BuildRaceCardButtonWrapper = withConfig(theme => styled('div', { label: 'BuildRaceCardButtonWrapper' })<BuildRaceCardButtonWrapperPropsType>`
    ${({ variant }): SerializedStyles => setBuildRaceCardButtonWrapper(variant, theme)}
`);

interface ContentWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    isAntePostReverse: boolean;
}

const setContentWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-top: 8px;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css``;
};

export const ContentWrapper = withConfig(theme => styled('div', { label: 'ContentWrapper' }) <ContentWrapperPropsType>`
    ${({ variant }): SerializedStyles=> setContentWrapper(variant, theme)};
    display: flex;
    flex-direction: ${({ isAntePostReverse }): string => isAntePostReverse ? 'column-reverse' : 'column'};
`);
